export {default} from './ExpiringSection.connect';
